<template>
  <section class="nyd-header" :class="'is_' + type">
    <header>
      <section class="container">
        <div class="l" @click="handleReload" style="cursor: pointer">
          <template v-if="type === 'screen'">
            <img src="@/assets/imgs/logo.png" alt="Logo" />
            <h1 class="text">
              <div class="sub_tt">School of International Education</div>
              <div class="tt">Southern Medical University</div>
            </h1>
          </template>
          <template v-else>
            <img src="@/assets/imgs/logo.png" alt="Logo" />
            <h1 class="text">
              <div class="sub_tt">School of International Education</div>
              <div class="tt">Southern Medical University</div>
            </h1>
          </template>
        </div>
        <section class="r">
          <img src="@/assets/icons/search.png" @click="handleGotoSearch" />
          <span style="font-size: 1rem;" @click="handleGotoSearch">Search</span>
            <a class="link" @click="lngChange" target="_blank">简体中文</a>
        </section>
      </section>
    </header>
    <!-- <template v-if="type === 'plain'">
      <section class="topbar">
        <section class="container">Welcome to SMU | <a class="link" href="https://istudy.smu.edu.cn/pc/"
            target="_blank">简体中文</a></section>
      </section>
    </template> -->
    <nav>
      <div class="container">
        <ul class="lm-menu">
          <li class="lm-menu__item" v-for="item in list" :class="{ is_active: item.memu1Id == $route.query.memu1Id }" :key="item.memu1Id"
            @click="handleGoto(item.memu1Id)">
            <div class="lm-menu__title">{{ item.memuTitle }}</div>
            <!-- <ul class="lm-menu__submenu" v-if="item.memu1Id === 'y0lm76nzz2'">
              <li class="lm-menu__item"><a href="https://istudy.smu.edu.cn/pc_en/#/article?articleId=y0mghnp6nz">Example Project 1</a></li>
            </ul> -->
          </li>
        </ul>
      </div>
    </nav>
  </section>
</template>

<style lang="scss" scoped>
@import '@/assets/styles/variable.scss';

.nyd-header {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 999;
  // background: linear-gradient(0deg, rgba(0,0,0,0), rgba(0,0,0,1)); // 2
  background: linear-gradient(0deg, rgba(0, 0, 0, 0), #1459a2); // 3
  .container {
    margin: 0 auto;
    width: 1500px;
  }

  header {
    display: flex;

    img {
      display: block;
    }

    .container {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .l {
      display: flex;
      align-items: center;
      color: #fff;

      img {
        margin-right: 12px;
        height: 80px;
      }

      .text {
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-top: 0;
        margin-bottom: 0;
        line-height: .5em;
        letter-spacing: 1px;
      }

      .tt {
        font-size: 23px;
      }

      .sub_tt {
        text-align: left;
        font-size: 18px;
      }

    }

    .r {
      display: flex;
      align-items: center;
      font-size: 16px;
      color: #fff;
      cursor: pointer;

      img {
        margin-right: 12px;
        width: 20px;
        height: 20px;
      }

      .link {
        margin-left: 16px;
        border-left: 1px solid #fff;
        padding-left: 16px;
        color: #fff;
      }
    }
  }

  .topbar {
    line-height: 48px;
    text-align: right;
    letter-spacing: .08em;
    background-color: #e9eaeb
  }

  &.is_screen nav {
    background-color: transparent;
  }
  .topbar .link {
    padding-right: 8px;
  }

  nav {

    ul {
      display: flex;
      justify-content: center;
      line-height: 1.8;
      font-weight: 400;

      li {
        position: relative;
        margin-right: 29.688px;
        padding-top: 5px;
        padding-bottom: 8px;
        font-size: 1.25em;
        transition: all $transitionDuration;
        cursor: pointer;

        &:after {
          content: "";
          position: absolute;
          width: 100%;
          height: 3px;
          bottom: 0;
          left: 0;
          background-color: $primaryColor;
          visibility: hidden;
          transform: scaleX(0);
          transition: all $transitionDuration ease-in;
          z-index: 1;
        }

        &:last-child {
          margin-right: 0;
        }

        &:hover {
          color: $primaryColor;
          &:after {
            visibility: visible;
            transform: scaleX(1);
          }
        }
        &.is_active {
          font-weight: 600;
          color: $navbarActiveTextColor;
        }
      }
    }
  }

  .lm-menu {
    .lm-menu__item {
      position: relative;
      white-space: nowrap;
      // overflow: hidden;
      text-overflow: ellipsis;
      .lm-menu__item {
        padding-right: 8px;
        padding-left: 8px;
        margin-right: 8px;
        margin-left: 8px;
      }
      &:hover .lm-menu__submenu {
        display: block;
      }
    }
    .lm-menu__submenu {
      display: none;
      position: absolute;
      top: 59px;
      left: 0;
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.15), 0 3px 3px rgba(0, 0, 0, 0.15);
      border-radius: 4px;
      font-size: 14px;
      background-color: #fff;
      a:hover {
        color: $primaryColor;
      }
    }
  }

  &.is_screen {
    header {
      height: 90px; //120px;
    }

    .topbar {
      color: #fff;
      background-color: transparent;

      a {
        color: #fff;
      }
    }

    nav {
      text-shadow: rgba(0,0,0,.6) 0 1px 8px;
      color: #fff;
      ul {
        font-weight: 600;
      }
    }
  }

  &.is_plain {
    box-shadow: 0 0 10px rgba(0,0,0,.15), 0 3px 3px rgba(0,0,0,.15);
    header {
      height: 90px;
      // background-color: $primaryColor; // 2
      background: linear-gradient(to right, rgb(68, 120, 179), rgb(180, 17, 132), rgb(68, 120, 179)); // 3
    }
    nav {
      background-color: #fff;
    }
  }
}
</style>

<script>
import { frontFnMenu } from '@/api/api';
const incules = [
  'y0lm76k9by',
  'y0lm76lhgr',
  'y0lm76m9z3',
  'y0lm76mqb0',
  'y0lm76n5u1',
  'y0lm76nibq',
  'y0lm76nzz2',
  'y0lm76obd6',
  'y0lm76oogy',
  'y0lm76pdhn'
]

export default {
  props: {
    type: {
      type: String,
      require: true
    }
  },
  data() {
    return {
      list: []
    }
  },
  created() {
    this.getMenuData();
  },
  methods: {
    lngChange() {
      localStorage.language = "zh-cn";
      location.href = 'https://istudy.smu.edu.cn/pc/'
    },
    getMenuData() {
      frontFnMenu({
        languageId: 'enNew',
        siteId: 'www'
      }).then(res => {
        this.list = res.data.memus1.filter(memu => incules.includes(memu.memu1Id))
      })
    },
    handleGoto(memu1Id) {
      if(memu1Id === 'y0lm76k9by') {
        this.$router.push({ path: `/` })
      } else {
        this.$router.push({
          path: `/column?memu1Id=${memu1Id}`
        })
        document.documentElement.scrollTop = 0
      }
    },
    handleGotoSearch() {
      this.$message.success({
        message: 'Upgrading。。。',
      })
    },
    handleReload() {
        this.$router.push({ path: `/` })
    }
  }
}
</script>
